import { ApiStatus } from '../../types';
import {
    ContractAEM,
    contractDefaultAEM,
    ContractEndpoints,
    ContractState,
} from './contractTypes';

export const initialStateContract: ContractState = {
    contractDetails: {
        status: '',
        message: '',
        contractFiles: [],
    },
    consentDetails: {
        hasConsent: true,
        consentId: '',
        consentStatus: '',
    },
    applicationNumber: '',
    aem: contractDefaultAEM,
    apiEndpoints: {
        createContractUrl: '/contract/contract-details',
        acceptContractUrl: '/contract/contract-acceptance',
    },
    createContractApiStatus: ApiStatus.Idle,
    acceptContractApiStatus: ApiStatus.Idle,
};

export const getContractPreloadData = (aem: ContractAEM, apiEndpoints: ContractEndpoints): ContractState => (
    {
        ...initialStateContract, aem, apiEndpoints,
    }
);
